import { Button, Container, Flex } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { EmptyState } from '../components/EmptyState'
import { Section } from '../components/Section'
import { redirectToLogout } from '../hooks/useAccount'
import { House, Logout, Refresh } from '../icons'

export default function UnauthorizedPage() {
  const navigate = useNavigate()

  return (
    <Section>
      <Container>
        <EmptyState
          title="Přístup odepřen"
          cta={
            <Flex flexDir={'column'} gap={4} alignItems={'center'}>
              <Button
                variant={'solid'}
                colorScheme="primary"
                className="btn btn-blue mt-6"
                onClick={
                  // Attempt to recover by trying to refresh the page
                  () => navigate(0)
                }
              >
                <Refresh />
                Zkusit znovu
              </Button>
              <Button
                variant={'solid'}
                className="btn btn-blue mt-6"
                onClick={() => navigate('/')}
              >
                <House /> Přejít na hlavní stránku
              </Button>
              <Button onClick={redirectToLogout}>
                <Logout />
                Odhlásit se
              </Button>
            </Flex>
          }
        />
      </Container>
    </Section>
  )
}
